import styled, { css } from 'styled-components';
import { Box } from '@material-ui/core';
import InfoOutlined from '@material-ui/icons/InfoOutlined';

const TooltipBody = styled(Box)`
  border-radius: var(--border-radius-08);
  box-shadow: 0 8px 16px -2px rgba(27, 33, 44, 0.12);
  color: var(--color-nero);

  & + .MuiTooltip-arrow {
    color: var(--color-white);
  }
`;

const InfoIcon = styled(InfoOutlined)`
  color: var(--color-grey3);
  cursor: help;
  font-size: 16px;
  vertical-align: middle;
`;

const Status = styled.div`
  left: 0;
  position: absolute;
  top: 100%;
`;

const SwitchSlot = styled.span<{ $disabled?: boolean }>`
  display: inline-flex;

  ${({ $disabled }) =>
    $disabled &&
    css`
      .MuiIconButton-root,
      .MuiSwitch-switchBase {
        cursor: not-allowed;
      }

      .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
        background-color: var(--color-grey4);
      }

      .MuiSwitch-switchBase.Mui-disabled {
        opacity: 0.55;
      }
    `}
`;

export const Styled = {
  TooltipBody,
  InfoIcon,
  Status,
  SwitchSlot,
};
